<template>
    <div>
        <div v-loading="loading" class="confirm_new-wrapper">
            <div class="bkgwrap" :style="{ backgroundImage: `url(${imgUrl_})` }">
                <div class="bkgwrap_con">
                    <p class="name">{{ detail.member_name }}</p>
                    <p v-if="!loading" class="zp_name">《{{ detail.info.title }}》</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { zuopinInfo } from '@/api/Tougaos'

export default {
    name: 'ConfirmNew',
    components: {},
    data() {
        return {
            zuopin_id: this.$route.query.zpid,
            loading: false,
            detail: { member_name: '', info: { title: '' } }
        }
    },

    computed: {
        imgUrl_() {
            const src_1 = require('../../assets/images/recepit_bkg.png')
            const src_2 = require('../../assets/images/recepit_bkg_2.png')
            if (!this.detail.status) return ''
            return this.detail.status === 90 ? src_2 : src_1
        }
    },

    created() {
        this.getZuopinInfo(this.zuopin_id)
    },

    methods: {
        getZuopinInfo(id) {
            this.loading = true
            zuopinInfo({ id })
                .then((res) => {
                    if (res.code === 200) {
                        this.detail = res.data.data
                    }
                })
                .finally(() => (this.loading = false))
        },

        back() {
            this.$router.go(-1) // 返回上一层
        },

        print() {
            window.print(0)
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.confirm_new-wrapper {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;

    .bkgwrap {
        max-width: 904px;
        width: 100%;
        flex: 1;
        background-repeat: no-repeat;
        background-size: contain;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .bkgwrap_con {
            transform: translateY(-30%);

            .name {
                font-weight: 900;
                font-size: 46px;
                text-align: center;
            }
            .zp_name {
                margin: 10px 0;
                text-align: center;
                font-weight: 500;
                font-size: 26px;
            }
        }
    }

    @media (max-width: 768px) {
        .bkgwrap {
            width: 375px;
            height: 500px;
            background-size: contain;

            .bkgwrap_con {
                position: absolute;
                top: 208px;
                left: 50%;
                transform: translateX(-50%);

                .name {
                    font-weight: 900;
                    font-size: 22px;
                    text-align: center;
                }
                .zp_name {
                    margin-top: -0px;
                    text-align: center;
                    font-weight: 500;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
